import { TrendingUp, TrendingDown } from 'lucide-react';

export default function MetricCard({ title, value, growth, icon: Icon, iconBgColor, iconColor }) {
  const isPositive = growth !== undefined && growth >= 0;
  const showGrowth = growth !== undefined && growth !== 0;

  return (
    <div className="card-wrapper !p-4 !rounded-2xl relative hover:scale-105 transition-transform cursor-pointer">
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <div className="flex items-center gap-3 mb-4">
            <div className={`${iconBgColor} ${iconColor} p-3 rounded-xl`}>
              <Icon className="w-5 h-5" />
            </div>
            {showGrowth && (
              <div className={`flex items-center gap-1 ${isPositive ? 'text-emerald-400' : 'text-red-400'}`}>
                {isPositive ? (
                  <TrendingUp className="w-4 h-4" />
                ) : (
                  <TrendingDown className="w-4 h-4" />
                )}
                <span className="text-sm font-medium">{Math.abs(growth)}%</span>
              </div>
            )}
          </div>
          <div className="text-3xl font-bold text-black mb-1">{value}</div>
          <div className="text-sm text-gray-600">{title}</div>
        </div>
      </div>
    </div>
  );
}
